<template>
  <div class="hall-places">
    <div class="row-label" style='grid-row: 1; grid-column: 1'> 1 </div>
    <div class="row-label" style='grid-row: 2; grid-column: 1'> 2 </div>
    <div class="row-label" style='grid-row: 3; grid-column: 1'> 3 </div>
    <div class="row-label" style='grid-row: 4; grid-column: 1'> 4 </div>
    <div class="row-label" style='grid-row: 5; grid-column: 1'> 5 </div>
    <div class="row-label" style='grid-row: 6; grid-column: 1'> 6 </div>
    <div class="row-label" style='grid-row: 7; grid-column: 1'> 7 </div>

    <div class="row-label" style='grid-row: 1; grid-column: 12'> {{ premiumPrice }} ₾ </div>
    <div class="row-label" style='grid-row: 2; grid-column: 12'> {{ premiumPrice }} ₾ </div>
    <div class="row-label" style='grid-row: 3; grid-column: 12'> {{ premiumPrice }} ₾ </div>
    <div class="row-label" style='grid-row: 4; grid-column: 12'> {{ standartPrice }} ₾ </div>
    <div class="row-label" style='grid-row: 5; grid-column: 12'> {{ standartPrice }} ₾ </div>
    <div class="row-label" style='grid-row: 6; grid-column: 12'> {{ standartPrice }} ₾ </div>
    <div class="row-label" style='grid-row: 7; grid-column: 12'> {{ lowPrice }} ₾ </div>
    <hall-seat v-for="seat in seatList"
          v-bind:key="seat.id"
          :col="seat.colPosition"
          :row="seat.rowPosition"
          :isFree="seat.free"
          :type="seat.seatType"
          :seat-id="seat.id">
      {{ seat.name }}
    </hall-seat>
  </div>
</template>

<script>
import HallSeat from './HallSeat.vue'

export default {
  name: 'HallSeats',
  components: {HallSeat},
  props: ['seatList', 'lowPrice', 'standartPrice', 'premiumPrice']
}
</script>

<style scoped>
.hall-places {
  display: grid;
  grid-template-columns: repeat(12, 1fr); /* Меняйте значения по своему усмотрению */
  grid-template-rows: repeat(7, 50px); /* Меняйте значения по своему усмотрению */
  grid-gap: 20px; /* Расстояние между изображениями */
  position: relative;
  padding-top: 60px;
}

.row-label {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/client/Seats/HallSeats.vue